import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { ArrowDown } from 'lucide-react';
import { useRecoilValue } from 'recoil';
import { showPoweredBySelector } from '@/state/config';
export const ScrollToBottomButton = ({ onClick, }) => {
    const showPoweredBy = useRecoilValue(showPoweredBySelector);
    return (_jsx("button", { className: cn('absolute bottom-30 left-1/2 z-1 flex h-8 w-8 -translate-x-1/2 cursor-pointer items-center justify-center', 'bg-bg-muted hover:bg-bg-muted rounded-full shadow-md transition-all', {
            'bottom-40': showPoweredBy,
        }), onClick: onClick, children: _jsx(ArrowDown, { className: "text-text-secondary-foreground h-4 w-4" }) }));
};
